import {Page} from "./Page";

export default class BestPracticePreamblePage extends Page {
    getNavTitle(): string {
        return 'Organizational Best Practice';
    }
}
